(function () {
  /* =====================================================================
     DeckWaechter - Sommer-Special Banner | "SOMMER-TRESOR ENTRIEGELT" v2
     Header (Toploader-Grafik + Headline + Countdown + CTA) ueber einem
     4-Stufen-Angebotsraster (1er/2er/3er/4er) mit Streichpreisen +
     Ersparnis. Anchoring + Verknappung (Countdown) + Self-Select.
     ===================================================================== */

  /* 1) Doppel-Init verhindern */
  if (window.__dwSummer) return; window.__dwSummer = true;

  /* 2) Nur Startseite (oder Vorschau via ?dwsummer=1) */
  var PREVIEW = /[?&]dwsummer=1/.test(location.search);
  if (location.pathname !== '/' && !PREVIEW) return;

  /* 3) Bereits in dieser Session weggeklickt? -> nichts tun */
  try { if (sessionStorage.getItem('dwss_closed') === '1') return; } catch (e) {}

  /* ---- EINZIGE Stelle zum Aendern des Enddatums (Tresor schliesst) ----- */
  var END = new Date('2026-07-14T23:59:59');
  /* --------------------------------------------------------------------- */

  /* 4) Schon abgelaufen? -> gar nicht erst rendern (kein Aufblitzen) */
  if (END.getTime() - Date.now() <= 0) return;

  var LINK = '/products/toploader-sleeves-set-3x4-fur-tcg-sammelkarten';

  /* ---------------------------------------------------------------------
     CSS - alles in EINEM <style>, jede Klasse mit dwss- Praefix
     --------------------------------------------------------------------- */
  var css = document.createElement('style');
  css.id = 'dwss-style';
  css.textContent =
    "@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@500;600;700&display=swap');" +

    /* Wrapper / Tresor-Buehne */
    ".dwss-wrap{position:relative;width:100%;box-sizing:border-box;overflow:hidden;" +
      "font-family:'Oswald',system-ui,Arial,sans-serif;color:#fff;isolation:isolate;" +
      "background:radial-gradient(120% 150% at 50% -20%,#2a0d08 0%,#140708 44%,#0a0405 100%);" +
      "border-bottom:1px solid rgba(255,90,42,.28);" +
      "box-shadow:0 14px 40px -14px rgba(255,70,25,.55);}" +
    ".dwss-wrap *{box-sizing:border-box;}" +

    /* Gluehende Tresor-Naht */
    ".dwss-seam{position:absolute;left:0;top:0;width:100%;height:3px;z-index:4;pointer-events:none;" +
      "background:linear-gradient(90deg,transparent,#ffb24a,#FF6A00,#FF3B2F,#FF6A00,#ffb24a,transparent);" +
      "filter:blur(.3px);box-shadow:0 0 18px 2px rgba(255,90,30,.85),0 0 42px 6px rgba(255,60,25,.45);}" +
    ".dwss-seam:after{content:'';position:absolute;inset:0;" +
      "background:linear-gradient(90deg,transparent,rgba(255,255,255,.95),transparent);" +
      "width:34%;transform:translateX(-140%);animation:dwssSeam 4.6s ease-in-out infinite;}" +

    /* Ember-Glow */
    ".dwss-glow{position:absolute;left:50%;bottom:-46%;width:82%;height:120%;z-index:0;transform:translateX(-50%);" +
      "background:radial-gradient(closest-side,rgba(255,106,0,.28),rgba(255,59,47,.10) 55%,transparent 72%);" +
      "animation:dwssBreathe 5.5s ease-in-out infinite;pointer-events:none;}" +

    /* Funken */
    ".dwss-sparks{position:absolute;inset:0;z-index:1;pointer-events:none;}" +
    ".dwss-spark{position:absolute;bottom:-8px;width:3px;height:3px;border-radius:50%;" +
      "background:#ffce8a;box-shadow:0 0 7px 1px rgba(255,150,60,.9);opacity:0;" +
      "animation:dwssRise linear infinite;}" +

    /* Inhalt: jetzt zweizeilig (Header-Reihe + Angebotsraster) */
    ".dwss-inner{position:relative;z-index:3;max-width:1180px;margin:0 auto;" +
      "display:flex;flex-direction:column;gap:15px;padding:16px 56px 18px 26px;}" +

    /* Header-Reihe */
    ".dwss-top{display:flex;align-items:center;gap:24px;}" +
    ".dwss-brand{flex:1 1 auto;min-width:0;display:flex;align-items:center;gap:16px;}" +
    ".dwss-tl{width:52px;height:70px;flex:none;filter:drop-shadow(0 5px 16px rgba(255,90,30,.55));}" +
    ".dwss-seal{min-width:0;display:flex;flex-direction:column;gap:6px;align-items:flex-start;}" +
    ".dwss-kicker{display:inline-flex;align-items:center;gap:8px;background:rgba(255,90,42,.14);" +
      "border:1px solid rgba(255,120,80,.4);border-radius:99px;padding:4px 12px;" +
      "font-size:11px;font-weight:600;letter-spacing:2px;text-transform:uppercase;color:#ffb24a;white-space:nowrap;}" +
    ".dwss-lock{width:13px;height:13px;display:inline-block;flex:none;}" +
    ".dwss-head{font-size:25px;font-weight:700;line-height:1.05;text-transform:uppercase;letter-spacing:.4px;margin:0;}" +
    ".dwss-head .dwss-fire{background:linear-gradient(90deg,#FF3B2F,#FF6A00);-webkit-background-clip:text;background-clip:text;color:transparent;}" +
    ".dwss-ship{font-size:12px;font-weight:600;letter-spacing:.3px;color:#ffb24a;}" +
    ".dwss-ship b{color:#fff;}" +

    /* Rechts: Countdown + CTA */
    ".dwss-right{flex:none;display:flex;align-items:center;gap:20px;}" +
    ".dwss-count{display:flex;flex-direction:column;gap:5px;align-items:flex-end;}" +
    ".dwss-count-cap{font-size:10.5px;font-weight:600;letter-spacing:1.2px;text-transform:uppercase;color:#e9c7b4;white-space:nowrap;}" +
    ".dwss-clock{display:flex;gap:7px;}" +
    ".dwss-seg{display:flex;flex-direction:column;align-items:center;min-width:46px;" +
      "background:rgba(20,7,8,.72);border:1px solid rgba(255,120,70,.34);border-radius:9px;padding:5px 6px 4px;}" +
    ".dwss-seg b{font-size:20px;font-weight:700;line-height:1;color:#fff;font-variant-numeric:tabular-nums;letter-spacing:.5px;}" +
    ".dwss-seg span{font-size:9px;font-weight:600;letter-spacing:.8px;text-transform:uppercase;color:#c79a86;margin-top:3px;}" +
    ".dwss-cta{flex:none;display:inline-flex;align-items:center;gap:9px;text-decoration:none;white-space:nowrap;" +
      "background:linear-gradient(90deg,#FF3B2F,#FF6A00);color:#170505;font-family:'Oswald',sans-serif;" +
      "font-size:15px;font-weight:700;letter-spacing:.6px;text-transform:uppercase;" +
      "border-radius:99px;padding:13px 26px;box-shadow:0 8px 26px -6px rgba(255,80,25,.7),inset 0 1px 0 rgba(255,255,255,.35);" +
      "transition:transform .15s ease,box-shadow .15s ease;}" +
    ".dwss-cta:hover{transform:translateY(-1px);box-shadow:0 12px 32px -6px rgba(255,90,30,.85),inset 0 1px 0 rgba(255,255,255,.45);}" +
    ".dwss-cta:active{transform:translateY(0) scale(.98);}" +
    ".dwss-cta:focus-visible{outline:2px solid #fff;outline-offset:3px;}" +
    ".dwss-cta .dwss-arrow{transition:transform .15s ease;}" +
    ".dwss-cta:hover .dwss-arrow{transform:translateX(3px);}" +

    /* Angebotsraster: 4 Set-Stufen */
    ".dwss-offers{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;}" +
    ".dwss-tile{position:relative;display:flex;flex-direction:column;gap:2px;text-decoration:none;color:#fff;" +
      "background:rgba(20,7,8,.55);border:1px solid rgba(255,120,70,.28);border-radius:12px;padding:11px 13px 12px;" +
      "transition:transform .15s ease,border-color .15s ease,background .15s ease;}" +
    ".dwss-tile:hover{transform:translateY(-2px);border-color:rgba(255,150,90,.7);background:rgba(42,14,9,.72);}" +
    ".dwss-tile:focus-visible{outline:2px solid #ffb24a;outline-offset:2px;}" +
    ".dwss-tile.dwss-hero{border-color:rgba(255,150,80,.85);" +
      "background:linear-gradient(180deg,rgba(64,22,11,.72),rgba(20,7,8,.6));" +
      "box-shadow:0 10px 28px -12px rgba(255,90,30,.75);}" +
    ".dwss-badge{position:absolute;top:-9px;left:12px;font-size:9.5px;font-weight:700;letter-spacing:.6px;" +
      "text-transform:uppercase;color:#170505;background:linear-gradient(90deg,#FF3B2F,#FF6A00);" +
      "border-radius:99px;padding:2px 9px;box-shadow:0 3px 10px -2px rgba(255,90,30,.85);white-space:nowrap;}" +
    ".dwss-tier{font-size:13px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;color:#fff;}" +
    ".dwss-qty{font-size:10.5px;font-weight:600;letter-spacing:.3px;text-transform:uppercase;color:#c79a86;}" +
    ".dwss-tprice{display:flex;align-items:baseline;gap:7px;margin-top:3px;flex-wrap:wrap;}" +
    ".dwss-tnow{font-size:21px;font-weight:700;line-height:1;color:#fff;font-variant-numeric:tabular-nums;}" +
    ".dwss-twas{font-size:12px;font-weight:500;color:#c79a86;text-decoration:line-through;" +
      "text-decoration-color:rgba(255,90,42,.9);text-decoration-thickness:2px;font-variant-numeric:tabular-nums;}" +
    ".dwss-tsave{display:inline-block;margin-top:2px;font-size:11.5px;font-weight:700;letter-spacing:.2px;color:#ffb24a;}" +

    /* Schliessen-Button */
    ".dwss-x{position:absolute;top:10px;right:12px;z-index:6;width:30px;height:30px;border-radius:50%;border:1px solid rgba(255,120,70,.3);" +
      "background:rgba(20,7,8,.6);color:#ffb24a;font-size:17px;line-height:1;cursor:pointer;padding:0;" +
      "display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:transparent;transition:background .15s ease,color .15s ease,transform .15s ease;}" +
    ".dwss-x:hover{background:rgba(255,90,42,.2);color:#fff;}" +
    ".dwss-x:active{transform:scale(.9);}" +
    ".dwss-x:focus-visible{outline:2px solid #ffb24a;outline-offset:2px;}" +

    /* Animationen */
    "@keyframes dwssSeam{0%{transform:translateX(-140%)}55%{transform:translateX(420%)}100%{transform:translateX(420%)}}" +
    "@keyframes dwssBreathe{0%,100%{opacity:.7}50%{opacity:1}}" +
    "@keyframes dwssRise{0%{opacity:0;transform:translateY(0) scale(1)}12%{opacity:1}100%{opacity:0;transform:translateY(-130px) scale(.4)}}" +
    "@keyframes dwssReveal{0%{opacity:0;transform:translateY(-10px)}100%{opacity:1;transform:translateY(0)}}" +
    ".dwss-wrap{animation:dwssReveal .6s ease both;}" +

    /* ---------- Responsive: Tablet ---------- */
    "@media(max-width:980px){" +
      ".dwss-inner{gap:14px;padding:16px 52px 16px 20px;}" +
      ".dwss-top{flex-wrap:wrap;gap:16px;}" +
      ".dwss-right{flex:1 1 100%;justify-content:space-between;}" +
      ".dwss-head{font-size:21px;}" +
    "}" +

    /* ---------- Responsive: Mobil ---------- */
    "@media(max-width:680px){" +
      ".dwss-inner{gap:14px;padding:16px 16px 18px;}" +
      ".dwss-top{flex-direction:column;align-items:stretch;gap:14px;}" +
      ".dwss-brand{flex-direction:column;align-items:center;text-align:center;gap:11px;}" +
      ".dwss-seal{align-items:center;text-align:center;}" +
      ".dwss-head{font-size:21px;}" +
      ".dwss-offers{grid-template-columns:repeat(2,1fr);gap:9px;}" +
      ".dwss-right{flex-direction:column;gap:13px;align-items:stretch;}" +
      ".dwss-count{align-items:center;}" +
      ".dwss-clock{justify-content:center;}" +
      ".dwss-cta{justify-content:center;width:100%;font-size:15px;padding:14px 20px;}" +
    "}" +
    "@media(max-width:360px){" +
      ".dwss-head{font-size:19px;}" +
      ".dwss-tnow{font-size:19px;}" +
      ".dwss-tile{padding:10px 10px 11px;}" +
      ".dwss-clock{gap:5px;}" +
      ".dwss-seg{min-width:40px;}" +
      ".dwss-seg b{font-size:18px;}" +
    "}" +

    /* ---------- Reduzierte Bewegung respektieren ---------- */
    "@media(prefers-reduced-motion:reduce){" +
      ".dwss-wrap,.dwss-seam:after,.dwss-glow,.dwss-spark,.dwss-cta,.dwss-cta .dwss-arrow,.dwss-tile{animation:none!important;transition:none!important;}" +
      ".dwss-glow{opacity:.85;}" +
    "}";
  (document.head || document.documentElement).appendChild(css);

  /* ---------------------------------------------------------------------
     Bausteine
     --------------------------------------------------------------------- */
  var LOCK_SVG = '<svg class="dwss-lock" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 10V7a5 5 0 0 1 9.6-2" stroke="#ffb24a" stroke-width="2" stroke-linecap="round"/><rect x="4.5" y="10" width="15" height="10" rx="2.5" stroke="#ffb24a" stroke-width="2"/><circle cx="12" cy="15" r="1.6" fill="#ffb24a"/></svg>';

  /* Toploader-Grafik: Karte in durchsichtigem Schutz-Holder + Flamme */
  var TL_SVG =
    '<svg class="dwss-tl" viewBox="0 0 48 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<defs><linearGradient id="dwtlCard" x1="0" y1="0" x2="1" y2="1"><stop stop-color="#FF6A00"/><stop offset="1" stop-color="#FF3B2F"/></linearGradient></defs>' +
      '<rect x="11" y="4" width="26" height="42" rx="3" fill="url(#dwtlCard)"/>' +
      '<path d="M24 13c2.6 3.4 4.2 5.4 4.2 8.6a4.2 4.2 0 0 1-8.4 0c0-2 .9-3.2 2-5 .5 1.4 1.4 1.8 1.4 3 .9-1.4.2-3.4-.2-6.6Z" fill="#1c0703"/>' +
      '<path d="M9 13.5C9 12 10.1 11 11.5 11h25c1.4 0 2.5 1 2.5 2.5V57c0 1.7-1.3 3-3 3H12c-1.7 0-3-1.3-3-3V13.5Z" fill="rgba(255,180,120,.10)" stroke="#ffb24a" stroke-width="2"/>' +
      '<path d="M13 15.5v39" stroke="rgba(255,245,230,.5)" stroke-width="1.5" stroke-linecap="round"/>' +
      '<path d="M12.5 12h23" stroke="#ffd9a0" stroke-width="2.4" stroke-linecap="round"/>' +
    '</svg>';

  function tile(opts) {
    return '<a class="dwss-tile' + (opts.hero ? ' dwss-hero' : '') + '" href="' + LINK + '">' +
      (opts.badge ? '<span class="dwss-badge">' + opts.badge + '</span>' : '') +
      '<span class="dwss-tier">' + opts.tier + '</span>' +
      '<span class="dwss-qty">' + opts.qty + '</span>' +
      '<span class="dwss-tprice"><span class="dwss-tnow">' + opts.now + '&nbsp;&euro;</span>' +
        '<span class="dwss-twas">' + opts.was + '&nbsp;&euro;</span></span>' +
      '<span class="dwss-tsave">spar ' + opts.save + '&nbsp;&euro;</span>' +
    '</a>';
  }

  var OFFERS =
    tile({ hero: true, badge: '&#9733; Beliebt &middot; &minus;38&thinsp;%', tier: '1er Set', qty: '100 + 100', now: '10,49', was: '16,99', save: '6,50' }) +
    tile({ tier: '2er Set', qty: '200 + 200', now: '20,49', was: '30,99', save: '10,50' }) +
    tile({ tier: '3er Set', qty: '300 + 300', now: '29,49', was: '39,99', save: '10,50' }) +
    tile({ tier: '4er Set', qty: '400 + 400', now: '38,99', was: '49,99', save: '11,00' });

  /* ----------------------------------------------------------------------
     Banner-Markup
     --------------------------------------------------------------------- */
  var bar = document.createElement('section');
  bar.className = 'dwss-wrap';
  bar.setAttribute('role', 'region');
  bar.setAttribute('aria-label', 'DeckWaechter Sommer-Special');

  var sparks = '';
  for (var i = 0; i < 14; i++) {
    var left = (6 + i * 6.6).toFixed(1);
    var dur = (3.4 + (i % 5) * 0.7).toFixed(2);
    var delay = (i * 0.42).toFixed(2);
    sparks += '<i class="dwss-spark" style="left:' + left + '%;animation-duration:' + dur + 's;animation-delay:' + delay + 's;"></i>';
  }

  bar.innerHTML =
    '<span class="dwss-seam" aria-hidden="true"></span>' +
    '<span class="dwss-glow" aria-hidden="true"></span>' +
    '<div class="dwss-sparks" aria-hidden="true">' + sparks + '</div>' +
    '<button class="dwss-x" type="button" aria-label="Schliessen">&times;</button>' +
    '<div class="dwss-inner">' +
      '<div class="dwss-top">' +
        '<div class="dwss-brand">' +
          TL_SVG +
          '<div class="dwss-seal">' +
            '<span class="dwss-kicker">' + LOCK_SVG + 'Sommer-Tresor entriegelt</span>' +
            '<h2 class="dwss-head">Der W&auml;chter &ouml;ffnet den Sommer-Tresor &middot; <span class="dwss-fire">bis zu 38&thinsp;% auf Toploader &amp; Sleeves</span></h2>' +
            '<span class="dwss-ship"><b>100er Set ab 10,49&nbsp;&euro;</b> &middot; Gratis Versand ab 29,99&nbsp;&euro; &middot; Hits bleiben mint</span>' +
          '</div>' +
        '</div>' +
        '<div class="dwss-right">' +
          '<div class="dwss-count" role="timer" aria-label="Bevor sich der Tresor wieder schliesst">' +
            '<span class="dwss-count-cap">Bevor sich der Tresor wieder schlie&szlig;t</span>' +
            '<div class="dwss-clock">' +
              '<span class="dwss-seg"><b data-d>00</b><span>Tage</span></span>' +
              '<span class="dwss-seg"><b data-h>00</b><span>Std</span></span>' +
              '<span class="dwss-seg"><b data-m>00</b><span>Min</span></span>' +
              '<span class="dwss-seg"><b data-s>00</b><span>Sek</span></span>' +
            '</div>' +
          '</div>' +
          '<a class="dwss-cta" href="' + LINK + '">Jetzt sichern <span class="dwss-arrow" aria-hidden="true">&rarr;</span></a>' +
        '</div>' +
      '</div>' +
      '<div class="dwss-offers">' + OFFERS + '</div>' +
    '</div>';

  var dEl = bar.querySelector('[data-d]'),
      hEl = bar.querySelector('[data-h]'),
      mEl = bar.querySelector('[data-m]'),
      sEl = bar.querySelector('[data-s]');
  var timer = null;

  function two(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    var diff = END.getTime() - Date.now();
    if (diff <= 0) {
      if (timer) { clearInterval(timer); timer = null; }
      bar.style.display = 'none';
      return;
    }
    var s = Math.floor(diff / 1000);
    var days = Math.floor(s / 86400); s -= days * 86400;
    var hrs = Math.floor(s / 3600); s -= hrs * 3600;
    var min = Math.floor(s / 60); s -= min * 60;
    if (dEl) dEl.textContent = two(days);
    if (hEl) hEl.textContent = two(hrs);
    if (mEl) mEl.textContent = two(min);
    if (sEl) sEl.textContent = two(s);
  }

  function place() {
    var host = document.querySelector('#MainContent') || document.body;
    if (!host) return false;
    host.insertBefore(bar, host.firstChild);
    bar.querySelector('.dwss-x').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      bar.style.display = 'none';
      if (timer) { clearInterval(timer); timer = null; }
      try { sessionStorage.setItem('dwss_closed', '1'); } catch (e2) {}
    });
    tick();
    timer = setInterval(tick, 1000);
    return true;
  }

  function mount() {
    if (place()) return;
    var obs = new MutationObserver(function () {
      if (document.querySelector('#MainContent') || document.body) {
        if (place()) obs.disconnect();
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
})();
